import { RangeType } from '../enums';

export const RangeTypes = [RangeType.DAY, RangeType.WEEK, RangeType.MONTH, RangeType.YEAR];
